import React, { ReactElement } from 'react'
import { Flex, Text, theme } from '@mindfulchefuk/design-system'

type TRecipeModalStat = {
  title: string
  content: string
}

export const RecipeModalStat = ({
  title,
  content,
}: TRecipeModalStat): ReactElement => (
  <Flex direction="column" mr={28}>
    <Text variant="body-md" color={theme.colors['pepper-500']}>
      {title}
    </Text>
    <Text variant="body-md-500-caps" color={theme.colors['pepper-500']}>
      {content}
    </Text>
  </Flex>
)
